var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_7695_54)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7695_54",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7695_54",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7695_54",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEeElEQVR4nO2dTYgcRRSAa9FExMSfSDJTrzdGQ4gaD0piTC6RIF71IOQq6iFoIMhm5r2eeBlBLxLiDwgaRTDxIKgnRS8KueQgIYe4zu57HZWY5KBRCPlRD2bNhNo9CGLPzrDTVTVT74MHC9v0vn1f1093V3cboyiKoiiKoiiKoihKYtSpuB9Q9liSV4Dk0CiFdTnn8oLdL/eZUQeQn7TE3wFJdxzCIp+EnJ8wo8aGvadussiHQxcQqhPz8eTU2ZvNKLBl94lllvib0EWDqqUQf23aR280sQMkb4YuFviT8rqJGTfwAcrV0IUCb8FzNZp5wMSKJfkgfJHEt5T3TZTs6t4AxL8nKOS8+99NbNRyvjt8cSRM7PthrYmNjGa3By8MhYmsUWwzsZHlvDNZITnvNLGhQiJDhUSGCokMFRIZIYRYlGl3RflO5JUu3M9A8r0O6iGEIB+vNU7e8t8DY3W7swJQTugsy7OQeku2lrXWSSoeUSE+haD8ulgX6rbxlU/y5yGWRBYT4rZRIf66rJ/7aCFnVIg3IXx+cSH8mwrx10Iu99FCrqgQfy1kblEhxHMqxF8L6brFFGUyNrU7y33mkvwsC0i6q/aeurVMyPr8p9tUiOcTwzX7p2tlQlY3O3UV4ksI8j+W5BN3iaRUSLuzwm3jttUuq7qB/Jol+cLi7GbTJ26JDhAfqXqAT2wM4YFF+BaTiBBesghfYsZcCA9dRNVixlRI9SKqEjNmQvyLGLaYMRESXsSwxIyDkF/qyA+bSKm3ZOsgN7hGXkjWLJ42kQNNfiYZIe6et4mcrFFsS0YIIKOJHIuSpyOE5A8gfrbXFdtQuJwA+TlA+TMlIUsP5DfKcnG/85mLCqH5VYvvlgpZeOhfhXhtIcRHerSQj1SI5y7Lonzao4V8pkJ8CyH+skcL+UqFeBPCM25K2usW7l2t6Tss8m4gPuYu0VSdU3KDukU+ByhvZXnx4KB5AfK9FvllS/yjCllal/SXeyjfYrHDmO7E0g+Z7oTb1/w+5/etLWSQbumSe8eWqfSqrlzWLqv/o/KQqRhAfk+F9N1dyTtVC3Enliqk70FcLtQbM+uqkuH27f6GChloZiUXXEtxU9yhxsI+hyYjyWkvRB4qhMJLUCEUvvAqhMIXW4VQ+AKrkAiKCiokfCFBhYQvHqiQ8AUDFRK+SKBC9Ew9KlK+dLKmVaw3sZGuED42nDuaQyY1IZbkb4vy+VpkMDHSWwhfs8hv2xZvmZzqrHKrQkY9NrU7y03M9BJiUQ6Ezi85egmpNeSe0Pklh1szVSZk3Yunbw+dX3K41yWVPVNRp9mnQueXJBbl6P+PIXwOmsVDofNLjgxlqnSm5b5NhXzcvaVnLALlwwxll4kZN1ZY5ItJnY8gHzQxs7DqPHyhwFe4d3LF+Mmjf+lOpPa1tiyXx0zUuC+2zT94Wf2zGRA6UK66VwqaUQCaxeOW+NvgRaPqwiK/ZEYNaM1uBOTnLcqroT/HDcMK5NfqefFo6NoqiqIoiqIoiqIoimIq5DqQAAwbsT72QAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.19530a2c83e722b52ff5fd2d2ed25d58.svg";
export { ForwardRef as ReactComponent };